"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _calendarProvider = require("../calendar-provider");

var _SpeakerCard = require("./SpeakerCard.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var socialTitle = {
  tw: 'Twitter',
  gh: 'Github',
  med: 'Medium',
  instagram: 'Instagram',
  bluesky: 'Bluesky',
  in: 'Linkedin',
  site: 'Site',
  default: 'GitNation.com'
};
var fallbackTechColor = 'white';

var selectQALink = function selectQALink(person) {
  try {
    return person.activities.talks[0].extension.qaLink;
  } catch (err) {
    return null;
  }
};

function SpeakerCard(props) {
  var _speakers$;

  var content = props.content,
      isOfflineCard = props.isOfflineCard,
      hideLabel = props.hideLabel,
      calendarLinkOptions = props.calendarLinkOptions;
  var data = content.data;
  var speakers = data.speakers || [content.data];
  var calendarLink = (0, _calendarProvider.createCalendarLink)(speakers, data.activities, calendarLinkOptions);
  var techColor = ((_speakers$ = speakers[0]) === null || _speakers$ === void 0 ? void 0 : _speakers$.tagBG) && speakers[0].tagBG !== 'black' ? speakers[0].tagBG : fallbackTechColor;
  var slug = speakers.map(function (s) {
    return s.slug;
  }).join('-');
  return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeaker, {
    id: "popup-".concat(slug)
  }, speakers.length > 0 && speakers.some(function (s) {
    return !!s.name;
  }) && /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTop, null, speakers.map(function (person, i) {
    return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerWrapper, {
      key: i
    }, person.avatar && /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatarWrap, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatar, {
      src: person.avatar,
      alt: person.name
    })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerDesc, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerName, null, person.name), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, person.companyWithCountry), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
      dangerouslySetInnerHTML: {
        __html: person.bio
      }
    })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.MobileOnly, null, /*#__PURE__*/_react.default.createElement(SocialsBlock, {
      person: person
    })));
  })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerMidWrapper, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerMidLeft, null, data.activities.allTalks ? data.activities.allTalks.map(function (talk) {
    return /*#__PURE__*/_react.default.createElement(PopSpeakerContent, {
      key: talk.title,
      talk: talk,
      techColor: techColor,
      hideLabel: hideLabel,
      calendarLink: calendarLink
    });
  }) : null), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerMidRight, null, speakers.map(function (speaker, index) {
    return /*#__PURE__*/_react.default.createElement(SocialsBlock, {
      key: index,
      header: speakers.length > 1 && speaker.name,
      person: speaker
    });
  }))));
}

var SocialsBlock = function SocialsBlock(_ref) {
  var header = _ref.header,
      person = _ref.person;
  return person.socials && /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerSocials, null, header && /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerSocialsHeader, null, header), /*#__PURE__*/_react.default.createElement("div", null, person.socials.map(function (soc) {
    return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBtn, {
      key: soc.link,
      href: soc.link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, socialTitle[soc.icon] || socialTitle.default);
  })));
};

var PopSpeakerContent = function PopSpeakerContent(_ref2) {
  var talk = _ref2.talk,
      techColor = _ref2.techColor,
      hideLabel = _ref2.hideLabel,
      calendarLink = _ref2.calendarLink;
  var showInfo = talk.label && !hideLabel || talk.track || talk.timeString;
  return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerContentWrap, null, showInfo && /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerActivityInfo, {
    color: techColor
  }, !hideLabel && talk.label && /*#__PURE__*/_react.default.createElement("span", null, talk.label), talk.track && /*#__PURE__*/_react.default.createElement("span", null, talk.track.name), talk.timeString && /*#__PURE__*/_react.default.createElement("span", {
    title: "time is show in your local browser tme"
  }, (0, _dayjs.default)(talk.timeString).format('HH:mm'))), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTitle, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCategory, null, talk.category == 2 ? 'Workshop: ' : 'Talk: '), talk.title), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
    dangerouslySetInnerHTML: {
      __html: talk.description
    }
  }), talk.timeString && calendarLink ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopCalendarButton, {
    title: "Add Talk to Calendar",
    href: calendarLink,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Add Talk to Calendar") : null);
};

var _default = SpeakerCard;
exports.default = _default;